import { render, staticRenderFns } from "./joiner_user.vue?vue&type=template&id=21c5f0bb&scoped=true&"
import script from "./joiner_user.vue?vue&type=script&lang=js&"
export * from "./joiner_user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c5f0bb",
  null
  
)

export default component.exports